module.exports = __webpack_public_path__ + "static/media/cardOne.bcc832cd.png";